import {Toast, ToastArea} from 'common/components/toast-area';
// import the whole module to make sure mp-toast-area is registered
import 'common/components/toast-area';

let _toastArea: ToastArea = null;

function _getToastArea(): ToastArea {
  if (!_toastArea) {
    _toastArea = document.createElement(`mp-toast-area`) as ToastArea;
    _toastArea.setAttribute(`elref`, `globalToastArea`);
    document.body.appendChild(_toastArea);
  }
  return _toastArea;
}

export function clearAllToasts() {
  _getToastArea().clearAllToasts();
}

export function addToast(toast: Toast): Toast {
  return _getToastArea().addToast(toast);
}

export function closeToast(toast: Toast) {
  _getToastArea().closeToast(toast);
}

/** Function used for test purposes only. We need to clear this variable when the dom is re-loaded  */
export function clearToastArea() {
  _toastArea = null;
}
